import Vue from 'vue';

// import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';

import Calc from './components/dividends_calc/main.vue';


var available_stocks = document.getElementById('default_stock_data').value;
available_stocks = JSON.parse(available_stocks);


function processPrivilege(stocks) {
  return stocks.forEach(v => {
    if (v.privilege) {
      v.name += ', привилегированные'
    }
  });
}

processPrivilege(available_stocks);

const roundDecimal = v => Math.round(v * 100) / 100;


var app = new Vue({
  el: '#entry-point',
  render: function (h) {
    return h(Calc, {
      props: {
        available_stocks: this.available_stocks
      }
    });
  },
  data: {
    available_stocks: available_stocks
  }
});